import graphql__947bab56bee844de636e from "./__generated__/ContributionsDatavizGraphRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams, useOutletContext } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import ContributionsDatavizGraph from "../ParticipativeModule/Visualizations/ContributionsDataviz/ContributionsDatavizGraph";

const ContributionsDatavizGraphRoute = props => {
  const { participativeModuleSlug } = useParams();
  const { contributionsPerPage: contributionsCount } = useOutletContext();

  return (
    <AppQueryRenderer
      key={participativeModuleSlug}
      query={ContributionsDatavizGraphRouteQuery}
      variables={{ participativeModuleSlug, contributionsCount }}
      component={ContributionsDatavizGraph}
      additionalProps={props}
    />
  );
};

const ContributionsDatavizGraphRouteQuery = graphql__947bab56bee844de636e;

export default ContributionsDatavizGraphRoute;
